import OWContainer from 'styles/styled-components/ow-container';
import { Spinner } from 'components/design';
import useController from '../controllers/add-nested-product-controller';
import { NestedProductForm } from '../components/nested-product-form';

export const AddNestedProductRoute = () => {
    const {
        formData,
        places,
        nestedProductCategories,
        onSubmit,
        onCancel,
        onChange,
        isLoading,
        isAddProductLoading,
        errors,
        isAdmin,
        websiteId,
        individualPrices,
        onSelectConfigChange,
        setIndividualPrices,
        placeConfigData,
        onConfigPriceChange,
        placeId,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <NestedProductForm
                    formData={formData}
                    places={places}
                    nestedProductCategories={nestedProductCategories}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onChange={onChange}
                    isSaveLoading={isAddProductLoading}
                    errors={errors}
                    isAdmin={isAdmin}
                    websiteId={websiteId}
                    individualPrices={individualPrices}
                    onSelectConfigChange={onSelectConfigChange}
                    setIndividualPrices={setIndividualPrices}
                    placeConfigData={placeConfigData}
                    onConfigPriceChange={onConfigPriceChange}
                    placeId={placeId}
                />
            )}
        </OWContainer>
    );
};
